import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/tree-care-leads-colorado")!;

export const Route = createFileRoute("/learn/tree-care-leads-colorado")({
  head: () => seoHead("/learn/tree-care-leads-colorado", "Colorado Tree Care & Fire Mitigation Marketing Guide", "Fire mitigation pages, storm cleanup, Google Maps, and reviews for Colorado tree care companies.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
